




































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';

import ModalMixin from '@/mixins/ModalMixin';
import TranslatedRouter from '@/mixins/TranslatedRouter';
import Signpost from '@/components/Signpost.vue';
import SendApp from '@/components/SendApp.vue';
import LangSwitch from '@/components/LangSwitch.vue';
import ContactForm from '@/components/ContactForm.vue';

import {Back, gsap, Power3} from '@/utils/gsap';

@Component({
	components: {
		'v-signpost': Signpost,
		'v-send-app': SendApp,
		'v-lang-switch': LangSwitch,
		'v-contact-form': ContactForm,
	}
})
export default class Modal extends Mixins(TranslatedRouter, ModalMixin) {
	@Prop({required: true}) readonly slug: string | null | undefined;

	modalName: string = 'modal-1';
	tl: any;

	$refs: {
		modal: HTMLElement
		modalInner: HTMLElement
		modalHeader: HTMLElement
	}

	get headerHeight(): number {
		return this.$store.state.headerInfo.height;
	}

	@Watch('headerHeight')
	onHeaderHeightChanged(newValue: number): void {
		this.setHeight(newValue);
	}

	@Watch('modalVisible')
	async onModalStateChanged(newValue: boolean): Promise<void> {
		await this.animateModal(newValue);
	}

	async mounted(): Promise<void> {
		if (typeof window === 'undefined') {
			return;
		}

		await this.$nextTick(() => this.setHeight(this.headerHeight));

		this.tl = gsap.timeline({paused: true});

		this.tl
			.fromTo(this.$refs.modal,
				{
					scale: 0.8,
					autoAlpha: 0,
					ease: Power3.easeInOut
				},
				{
					duration: 0.3,
					scale: 1,
					autoAlpha: 1,
					ease: Back.easeOut.config(4)
				}
			);

		window.addEventListener('resize', () => {
			if (!this.modalVisible) {
				return;
			}
			gsap.set(this.$refs.modalInner, {
				height: `${window.innerHeight - this.headerHeight}px`
			});
		})

		this.animateModal(this.modalVisible);

	}

	async animateModal(state: boolean): Promise<void> {
		let html = document.querySelector('html');

		if (state) {
			gsap.set(html, {
				position: 'fixed',
				overflow: 'hidden'
			});
			setTimeout(() => {
				gsap.set(this.$refs.modalInner, {
					height: `${window.innerHeight - this.headerHeight}px`
				})
			}, 500);
			this.tl.play();
		} else {
			gsap.set([html, this.$refs.modalInner], {
				clearProps: 'all'
			});
			this.tl.reverse();
		}

	}

	setHeight(height: number): void {
		if (!this.$refs.modalHeader) {
			return;
		}
		this.$refs.modalHeader.style.height = `${height}px`;
	}

	async closeModal(): Promise<void> {

		await this.toggleModal(this.slug as string);

		await this.$router.replace({
			query: {
				...this.$route.query,
				[this.$t('routes.getApp.modalPrefix') as string]: undefined
			}
		});
	}
}
